export const getCommentList = (state) => state.comment.data
export const getCommentListLoading = (state) => state.comment.loading
export const getCommentListError = (state) => state.comment.error

export const getCommentDetail = (state) => state.comment.detail
export const getCommentDetailLoading = (state) => state.comment.loadingDetail
export const getCommentDetailError = (state) => state.comment.error
